export function svgToImage(url, targetWidth = 2048) {
    const img = new Image()
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const DOMURL = window.URL || window.webkitURL || window
  
    const resultPromise = new Promise((resolve, reject) => {
      img.onload = function () {
        const width = targetWidth
        const height = (width / img.width) * img.height
  
        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        DOMURL.revokeObjectURL(url)
        const dataUrl = canvas.toDataURL()
        resolve(dataUrl)
      }
      img.onerror = function () {
        reject({ error: 'generating image failed' })
      }
    })
    img.crossOrigin = 'anonymous'
    img.src = url
  
    return resultPromise
  }
  